import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import _ from "lodash";
import i18n from "../../../lib/i18n/i18n";
import {
  Row,
  FieldText,
  Field,
  customStyles,
  Container,
} from "./TestTypesByMonth.styles";
import Button from "../../UiComponents/Buttons/Default";
import Select from "react-select";
import { connect } from "react-redux";
import { getBranches } from "../../../actions/branchActions";
import { getAllSchoolTestsEvents } from "../../../actions/schedulerActions";
import {
  BarChart,
  Bar,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const ActivityReport = ({ getAllSchoolTestsEvents, getBranches }) => {
  const [graphData, setGraphData] = useState([]);
  const [currentView, setCurrentView] = useState("bymonths");
  const [startDate, setStartDate] = useState(new Date().setMonth(0));
  const [endDate, setEndDate] = useState(new Date());
  const [selectedTeacher, setSelectedTeacher] = useState();
  const [selectOptions, setSelectOptions] = useState([]);
  const [rawGraphData, setRawGraphData] = useState([]);

  useEffect(() => {
    (async () => {
      let events = await getAllSchoolTestsEvents(
        new Date(`01-01-${new Date().getFullYear()}`),
        new Date(`12-31-${new Date().getFullYear()}`)
      );
      events = events.filter(
        (x) => x.eventType === 2 && x.eventStatus !== 3 && x.eventStatus !== 4
      );
      const data = [];
      setSelectedTeacher(null);
      for (
        let index = new Date(startDate).getMonth();
        index <= new Date(endDate).getMonth();
        index++
      ) {
        if (currentView === "byVehicles") {
          const uniqueVehicle = _.uniqBy(events, "vehicleNumber");
          const vehicels = uniqueVehicle
            .filter((x) => x.vehicleNumber !== null)
            .map((x) => x.vehicleNumber);
          setSelectOptions(vehicels.map((x) => ({ value: x, label: x })));
          filterByData(vehicels, index, "vehicleNumber", data, events);
        } else if (currentView === "byLicense") {
          const uniqueLicenses = _.uniqBy(events, "name");
          const licenses = uniqueLicenses
            .filter((x) => x.name !== null)
            .map((x) => x.name);
          setSelectOptions(licenses.map((x) => ({ value: x, label: x })));
          filterByData(licenses, index, "name", data, events);
        } else if (currentView === "byBranch") {
          const allBranches = await getBranches();
          setSelectOptions(
            allBranches.map((x) => ({ value: x.name, label: x.name }))
          );
          filterByData(allBranches, index, "branchId", data, events, true);
        } else if (currentView === "byUser") {
          const uniqueLicenses = _.uniqBy(events, "createUsername");
          const licenses = uniqueLicenses
            .filter((x) => x.createUsername !== null)
            .map((x) => x.createUsername);
          setSelectOptions(licenses.map((x) => ({ value: x, label: x })));
          filterByData(licenses, index, "createUsername", data, events);
        } else {
          setSelectOptions([]);
          const currentMonthTests = events.filter(
            (x) =>
              new Date(x.start).getMonth() === index &&
              new Date(x.start).getFullYear() === new Date().getFullYear()
          );
          data.push({
            date: index + 1,
            failed: currentMonthTests.filter((x) => x.testStatus === 2).length,
            passed: currentMonthTests.filter((x) => x.testStatus === 1).length,
            order: currentMonthTests.filter((x) => x.testStatus === 0).length,
          });
        }
      }
      setRawGraphData(data);
      setGraphData(data);
    })();
  }, [startDate, endDate, currentView]);

  const filterByData = (array, index, param, data, events, isBranch) => {
    for (let j = 0; j < array.length; j++) {
      const element = array[j];
      const elementValue = isBranch ? element.id : element;
      const currentMonthTests = events.filter(
        (x) =>
          new Date(x.start).getMonth() === index &&
          new Date(x.start).getFullYear() === new Date().getFullYear() &&
          x[param] === elementValue
      );

      data.push({
        date: `${isBranch ? element.name : element} - ${index + 1}`,
        failed: currentMonthTests.filter((x) => x.testStatus === 2).length,
        passed: currentMonthTests.filter((x) => x.testStatus === 1).length,
        order: currentMonthTests.filter((x) => x.testStatus === 0).length,
      });
    }
  };

  const handleChange = (selected) => {
    setSelectedTeacher(selected);
    if (selected && selected.length > 0) {
      let filteredData = [];
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        filteredData = [
          ...filteredData,
          ...rawGraphData.filter((x) => x.date.includes(element.value)),
        ];
      }
      setGraphData(filteredData);
    } else {
      setGraphData(rawGraphData);
    }
  };

  return (
    <Container>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <h1>התפלגות חודשית לטסטים</h1>
        <p>סטטוס כל הטסטים שלא בוטלו לפי חודש</p>
      </div>

      <Row>
        <Button
          text="לפי חודשים"
          onClick={() => {
            setCurrentView("byMonths");
          }}
          marginRight="1"
        />
        <Button
          text="לפי רכבים"
          onClick={() => {
            setCurrentView("byVehicles");
          }}
          marginRight="1"
        />
        <Button
          text="לפי רישון"
          onClick={() => {
            setCurrentView("byLicense");
          }}
          marginRight="1"
        />
        <Button
          text="לפי יוצר"
          onClick={() => {
            setCurrentView("byUser");
          }}
          marginRight="1"
        />
        <Button
          text="לפי סניפים"
          onClick={() => {
            setCurrentView("byBranch");
          }}
          marginRight="1"
        />
        <Select
          options={selectOptions}
          value={selectedTeacher}
          isMulti
          placeholder="בחר"
          styles={customStyles}
          onChange={handleChange}
          isRtl
        />
        <>
          <Field>
            <FieldText>עד</FieldText>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              selectsEnd
              locale={i18n.language}
              startDate={startDate}
              dateFormat="MMMM"
              endDate={endDate}
              minDate={startDate}
              showMonthYearPicker
              showFullMonthYearPicker
            />
          </Field>
          <Field>
            <FieldText>מ</FieldText>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              locale={i18n.language}
              dateFormat="MMMM"
              showMonthYearPicker
              showFullMonthYearPicker
              selectsStart
              startDate={startDate}
              endDate={endDate}
            />
          </Field>
        </>
      </Row>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={graphData}>
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="failed" fill="#8884d8" radius={[10, 10, 0, 0]} />
          <Bar dataKey="passed" fill="#82ca9d" radius={[10, 10, 0, 0]} />
          <Bar dataKey="order" fill="#ffc658" radius={[10, 10, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Container>
  );
};

export default connect(null, {
  getAllSchoolTestsEvents,
  getBranches,
})(ActivityReport);
